import React from "react";
import "./Certificates.scss";

const Certificates = ({
  data,
  heroImage = "",
  heroStamp = "",
  certificateImage = "",
  qrIcon = "",
}) => {
  const { hero, intro, ownership } = data;

  return (
    <div className="certificates-page">
      <>
        <section className="certificates-hero">
          {heroImage && (
            <div
              className="certificates-hero__bg"
              style={{ backgroundImage: `url(${heroImage})` }}
            />
          )}
          <div className="certificates-hero__overlay" />
          <h1 className="certificates-hero__title">{hero.title}</h1>
        </section>
        {heroStamp && (
          <img
            src={heroStamp}
            alt="Funooni Platform Certificate of Authenticity Stamp"
            className="certificates-hero__stamp"
          />
        )}
      </>

      <section className="certificates-intro">
        <div className="certificates-intro__body">
          <div className="certificates-intro__card">
            <div className="certificates-intro__card-content">
              <div className="certificates-intro__card-header">
                <span>{intro.cardLabel}</span>
              </div>
              <img
                src={heroStamp}
                alt={intro.title}
                className="certificates-intro__card-image"
              />
            </div>
            <div className="certificates-intro__badges">
              {intro.features.map((feature) => (
                <span key={feature} className="certificates-intro__badge">
                  {feature}
                </span>
              ))}
            </div>
          </div>

          <div className="certificates-intro__text">
            <h2 className="certificates-intro__heading">{intro.heading}</h2>
            <h3>{intro.title}</h3>
            <p>{intro.description}</p>
            {intro.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>

        <div className="certificates-intro__divider" />
        <p className="certificates-intro__note">{intro.note}</p>
      </section>

      <section className="certificates-ownership">
        <h2>{ownership.heading}</h2>
        <h3>{ownership.subheading}</h3>
        <p className="certificates-ownership-p">{ownership.secondSubheading}</p>
        <p className="certificates-ownership__intro">{ownership.intro}</p>

        {ownership.models.map((model) => (
          <div key={model.key} className="certificates-ownership__model">
            <h4>{model.title}</h4>
            {model.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {model.perks && model.perks.length > 0 && (
              <>
                <p className="certificates-ownership__perks-heading">
                  {model.perksHeading}
                </p>
                <div className="certificates-ownership__perks">
                  <div className="certificates-ownership__perks-first">
                    {model.perks.slice(0, 2).map((perk) => (
                      <span key={perk} className="certificates-ownership__perk">
                        {perk}
                      </span>
                    ))}
                  </div>

                  <div className="certificates-ownership__perks-grid">
                    {model.perks.slice(2).map((perk) => (
                      <span key={perk} className="certificates-ownership__perk">
                        {perk}
                      </span>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        ))}

        <div className="certificates-ownership__model certificates-ownership__model--full">
          <h4>{ownership.fullOwnership.title}</h4>
          {ownership.fullOwnership.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
          <p className="certificates-ownership__highlight">
            {ownership.fullOwnership.highlight}
          </p>
        </div>
      </section>

      <div className="certificates-page__divider" />
      <p className="certificates-page__footer-note">{ownership.footerNote}</p>
    </div>
  );
};

export default Certificates;
